export enum LegendTypes {
  TOGGLE_LEGEND = "@@LEGEND/TOGGLE_LEGEND",
}
